var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',[_c('cp-motor-contract-termination',{attrs:{"policy-id":_vm.policyId,"route-path":this.$router.currentRoute.path}})],1),_c('div',{staticClass:"imageWrapper"},[_vm._t("image",function(){return [_c('TeaserAccount')]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }